<template>
    <div>
       
        <el-table :data="tableData" v-loading="loading" max-height="500">
                
                <!-- <el-table-column label="工单类别" prop="category" minWidth="120" fixed></el-table-column> -->
                <el-table-column label="工单类别" prop="category" minWidth="50" fixed></el-table-column>
                <el-table-column label="编号" prop="serial_number" minWidth="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" class="hoverBtn" @click="goDetail(scope.row)">{{scope.row.serial_number}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="项目" prop="project_name" minWidth="120">
                    <template slot-scope="scope">
                        <!-- <el-button type="text">{{formatEvent(scope.row.project_name)}}</el-button> -->
                        {{formatEvent(scope.row.project_name)}}
                    </template>
                </el-table-column>
                <el-table-column label="工时（小时）" prop="work_time">
                </el-table-column>
                <el-table-column label="工作内容" prop="work_content" ></el-table-column>
                
            </el-table>
    </div>
</template>

<script>
    import services from "./personStatis.service";
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },

            category:String,
            internal_userid:String,
            start_date:String,
            end_date:String,
            message:String,
            callback:Function
        },
        data() {
            return {
                loading: false,
                rules:{
                  category:'',
                  internal_userid:'',
                  start_date:'',
                  end_date:''
                },
                tableData:[]
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            scheduling_work_type(){//类型名称
                return this.dictionary.scheduling_work_type;
            },
            project_name(){//项目名称
                return this.dictionary.project_name;
            },
        },
        mounted(){
            // console.log(this.start_date)
            this.$modal.title = "详情-" + this.message;
            this.rules={
              category:this.category,
              internal_userid:this.internal_userid,
              start_date:this.start_date,
              end_date:this.end_date
            },
            this.getDetail();
        },
        methods:{
           //格式化项目名称
           formatEvent(nameId){
                
                let projectCname=''
                if(this.project_name.length > 0){
                    projectCname = this.project_name.filter(item =>{
                        if(item.id == nameId){
                            // console.log(item)
                            return item
                        }
                    })
                }else{
                    console.log('this.project_name')
                }
                // console.log(projectCname)
                return projectCname[0] ? projectCname[0].cname : ''
           },
            getDetail(){//获取班次详情
                services.detailList(this.rules).then(res => {
                    // console.log(res)
                    this.tableData = res
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            goDetail(row){
                console.log(row)
                let routerurl = ''
                switch(row.category) {
                     case "事件":
                        routerurl = '/eventDetail'
                        break;
                     case "问题":
                       routerurl = '/problemDetail'
                        break;
                     case "变更":
                        routerurl = '/changeDetail'
                        break;
                     case "发布":
                        routerurl = '/deployDetail'
                        break;
                }
                // this.onCancel()
                let routeUrl = this.$router.resolve({
                 path: routerurl,
                 query: {
                   serialNumber:row.serial_number
                 }
               });
               window.open(routeUrl.href, '_blank');
                // this.$router.push({
                //   path: routerurl,
                //   query: {
                //     serialNumber:row.serial_number
                //   }
                // })

            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    
</style>
